module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-1.3ad53036.jpg";